import { Api } from "../config/request";

export default {
  getOnboardingCenter() {
    return Api.get("/onboarding-centre/user");
  },
  verifyIssuability(payload) {
    return Api.post("/driver-assets/issuance/diy/verification", payload);
  },
  imageUpload(payload) {
    return Api.post("/driver-assets/issuance/diy/verification/image", payload);
  },
  verifyOtp(payload) {
    return Api.post("/driver-assets/issuance/diy/otp/verify", payload);
  },
  sendOtp(payload) {
    return Api.post("/driver-assets/issuance/diy/otp/send", payload);
  },
};
